function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 35 35",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.59 8.785l2.396-.6 2.436 9.696 7.06.51-.176 2.463-8.845-.636-2.87-11.432z",
  fill: "#354147"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5 32.53c8.3 0 15.03-6.73 15.03-15.03 0-8.3-6.73-15.03-15.03-15.03C9.2 2.47 2.47 9.2 2.47 17.5c0 8.3 6.73 15.03 15.03 15.03zm0 2.47C27.165 35 35 27.165 35 17.5S27.165 0 17.5 0 0 7.835 0 17.5 7.835 35 17.5 35z",
  fill: "#354147"
})));